interface LeaderboardEmptyStateProps {
  /**
   * "zero" — board is empty; centered editorial message replaces the table.
   * "sparse" — fewer than 10 eligible users; editorial copy renders ABOVE the table.
   */
  variant: 'zero' | 'sparse';
}

export const LeaderboardEmptyState = ({ variant }: LeaderboardEmptyStateProps) => {
  if (variant === 'zero') {
    return (
      <div className="py-12 px-4 text-center">
        <p className="font-serif text-2xl text-gray-900 mb-2">No check-ins yet.</p>
        <p className="font-sans text-base text-gray-600 max-w-md mx-auto">
          Be the first explorer on the board. Check in from a winery page to start your trail.
        </p>
      </div>
    );
  }

  // sparse
  return (
    <div className="px-3 md:px-4 py-4 mb-2 border-b border-gray-200">
      <p className="font-serif text-lg text-gray-900 mb-1">Early days.</p>
      <p className="font-sans text-sm text-gray-600">
        Only a few explorers have checked in so far. Visit a winery, check in from your
        profile, and you&rsquo;ll appear on this board.
      </p>
    </div>
  );
};
